module.exports = __webpack_public_path__ + "img/reel.190981a9.jpg";